import { isEmpty } from 'lodash';

const getApplicationTypeResponse = (response) => {
  if (isEmpty(response?.data?.appTypes)) return [];

  return response?.data?.appTypes?.map((appType) => {
    return {
      id: appType?.id,
      value: appType?.id?.toString() || '',
      label: appType?.name,
    };
  });
};

export default getApplicationTypeResponse;
